import { render, staticRenderFns } from "./FilesCardView.vue?vue&type=template&id=548baaa7&scoped=true"
import script from "./FilesCardView.vue?vue&type=script&lang=js"
export * from "./FilesCardView.vue?vue&type=script&lang=js"
import style0 from "./FilesCardView.vue?vue&type=style&index=0&id=548baaa7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548baaa7",
  null
  
)

export default component.exports